export const Config = {
    serviceUrl: 'https://al5-app03.adia.tv',
    multitenantServices: true
};
